/**
 * The Strategy Analysis Setup answers a client file starts with — ONE place, because the bag is
 * app-level state and has to be put back whenever the file changes.
 *
 * Owner-caught, 18 Oct 2026: a new client file skipped the questions that change the answer and went
 * straight to the old annuity gate, because `suggestionEngineSetupComplete` set on the PREVIOUS file
 * was still true. The flag (and every other answer here) belongs to a file, not to the browser tab.
 */
import type { CoupleValidationState } from '../features/agedCare/AgedCareAnalyser.tsx';

export const INITIAL_COUPLE_VALIDATION: CoupleValidationState = {
    // exploreAlternatives is intentionally absent (undefined) = "not set" so the setup asks
    // null = "not set" so the setup can default it to ~70% of the actual home value
    downsizeNewHomeValue: null,
    partnerAnnualRent: 20000,
    sellingCosts: 0,
    emergencyFund: 0,
    // Optional future life event (partner enters residential care later) — captured in the setup
    enablePartnerFutureEvent: false,
    partnerEntryYear: 3,
    partnerFutureRoomPrice: 0,
    originalEntrantAliveAtPartnerEntry: true,
};

export function freshCoupleValidation(): CoupleValidationState {
    return { ...INITIAL_COUPLE_VALIDATION };
}
